export default __webpack_public_path__ + "static/8-74debbde15ca0d66ecd5876bb4b33359.png";